import axios from 'axios';
import config from '../../config';

import wrapper from 'axios-cache-plugin';

let foodCache = wrapper(axios, {
  maxCacheSize: Infinity
});

foodCache.__addFilter(/autocomplete/);
foodCache.__addFilter(/food/);

let FoodApi = {
  /**
   *
   * @param food
   */
  CancelToken: axios.CancelToken,
  CancelRequests: null,
  copyYesterdaysMeal(mealTypeId) {
    return axios.get(config.apiUrl + 'food/copyYesterdaysMeal/', {
      params: {
        mealTypeId: mealTypeId
      }
    })
  },
  withDate(date) {
    let self = this;
    return axios.get(config.apiUrl + 'food/withDate/' + date, {
      cancelToken: new self.CancelToken(function executor(c) {
        // An executor function receives a cancel function as a parameter
        self.CancelRequests = c;
      })
    })
  },
  updateRecipe(model) {
    return axios.put(config.apiUrl + 'food/recipe/', model);
  },
  deleteRecipe(id) {
    return axios.delete(config.apiUrl + 'food/recipe/' + id);

  },
  deleteFood(food_id) {
    let self = this;
    return axios.delete(config.apiUrl + 'food/' + food_id);
  },
  autoComplete(search) {
    let self = this;
    return foodCache({
      url: config.apiUrl + 'food/autocomplete/',
      method: 'get',
      params: {
        q: search
      },
      cancelToken: new self.CancelToken(function executor(c) {
        self.cancel = c;
      })
    });
  },
  getById(food_id) {
    return foodCache({
      url: config.apiUrl + 'food/' + food_id,
      method: 'get'
    });
  },
  getRecents(mealTypeId) {
    return axios.get(config.apiUrl + 'food/recents/' + mealTypeId)
  },
  searchFoods(food, page, page_size) {
    return axios.post(config.apiUrl + 'food/search/', {
      searchValue: food,
      page_number: page,
      page_size: page_size
    })
  },
  addFoods(model) {
    return axios.post(config.apiUrl + 'food/foods/', model);
  },
  updateFood(model) {
    return axios.put(config.apiUrl + 'food/update/', model);
  },
  getFoodWithDate(date, user_id = null) {
    let params = {};
    if (user_id) {
      params.user_id = user_id;
    }
    return axios.get(config.apiUrl + 'food/withDate/' + date, {
      params: params
    });
  },
  addToFavourites(model) {
    return axios.post(config.apiUrl + 'food/favourites/', model);
  },
  getFavorites() {
    return axios.get(config.apiUrl + 'food/favourites/');
  },
  deleteFavorite(mealId) {
    return axios.delete(config.apiUrl + 'food/favourites/' + mealId);
  }
};

export default FoodApi;




// WEBPACK FOOTER //
// ./src/api/Food/index.js